import styled from 'styled-components';
import { Card } from 'reactstrap';
export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  background-color: ${props => props.theme.background};
  justify-content: center;
  align-items: center;
`;

export const Content = styled(Card)`
  width: 100%;
  max-width: 315px;
  /* height: 20rem; */
  /* max-height: 20rem; */
  text-align: center;
  background-color: ${props => props.theme.cardBackgroud};
  padding: 25px;
  border-radius: 5px;

  form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }
  button {
    margin-top: 5px;
  }
  a {
    margin: 0px 0px 5px 10px;
    align-self: flex-end;
  }
`;
